import { createSlice } from '@reduxjs/toolkit';

import { UtilityCompany } from 'entities/UtilityCompany';
import { AppError } from 'entities/Errors';

import { getUtilityCompanyList } from './utility_company.action';

interface UtilityCompanyState {
  loading: boolean;
  error: null | AppError;
  utilityCompanies: UtilityCompany[];
}

const initialState = {
  loading: false,
  error: null,
  utilityCompanies: [],
} as UtilityCompanyState;

export const UtilityCompanySlice = createSlice({
  name: 'utilityCompany',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getUtilityCompanyList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUtilityCompanyList.fulfilled, (state, action) => {
        state.loading = false;
        state.utilityCompanies = action.payload.data;
      })
      .addCase(getUtilityCompanyList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default UtilityCompanySlice.reducer;
